<template>
  <div
    class="vt-side-panel thin-scroll"
    :class="classes"
  >
    <slot />
    <div
      v-if="loading"
      class="spinner-wrapper"
    >
      <vt-loading />
    </div>
  </div>
</template>

<script>
export default {
    name: 'VtSidePanel',
    props: {
        visible: { type: Boolean, default: false },
        loading: { type: Boolean, default: false }
    },
    computed: {
        classes() {
            return {
                'vt-side-panel-show': this.visible
            }
        }
    }
}

</script>

<style scoped lang="scss">

.vt-side-panel {
  display: none;
  position: fixed;
  top: 46px;
  padding-top: 1.5%;
  right: 0;
  height: calc(100vh - 75px); // TODO: Refactoring required for not absolute sizes
  width: 50%;
  z-index: 100;
  background-color: vt-color(sidepanel-bg);
  box-shadow: -2px 1px 5px 0 vt-color(sidepanel-box-shadow);
  border-left: 1px solid vt-color(sidepanel-border);
  padding-right: 0.5rem;
}

.vt-side-panel-show {
  display: block;
}

@media(max-width: 1300px){
  .vt-side-panel {
  width: 55%;
}
}

@media (min-width: 1301px) and (max-width: 1370px) {
.vt-side-panel {
  width: 57%;
}
}

</style>
